import '@/components/elements'
import '@/plugins/countryCodes'
import '@/plugins/custom'
import '@/plugins/date'
import '@/plugins/fragment'
import http from '@/plugins/http'
import '@/plugins/lodash'
import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import { requestPersistentStorage } from '@/utils/persistenceHealth'
import VueMask from 'v-mask'
import Vue from 'vue'
import App from './App.vue'
import auth from './plugins/auth'
import validation from './plugins/validation'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// TXP-806. Ask the browser to mark this origin's storage as persistent, so the clinical data held
// in IndexedDB is far less likely to be silently evicted when the device is under disk pressure.
// Eviction is one of the ways a write starts failing, which is what TXP-806 is about.
//
// This is deliberately NOT awaited: it must never delay the application mounting.
// requestPersistentStorage() has its own internal try/catch and returns false rather than
// rejecting, so this cannot produce an unhandled rejection.
requestPersistentStorage()

// Custom Plugins
Vue.use(validation)
Vue.use(VueMask)

const app = new Vue({
  http,
  router,
  store,
  config: { auth },
  vuetify,
  render: h => h(App),
}).$mount('#app')

if (window.Cypress) {
  window.app = app
}
